import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { create as apiCreate } from 'api';
import { showNotification } from 'store/actions/notifications';
import { NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'constants/notification';

// Passo final da venda criada pelo número do negócio (sem cliente ainda):
// gera o link único da venda, manda por e-mail e deixa copiar para o
// WhatsApp. O cliente preenche os dados e cai direto no contrato.

const mensagemDoErro = (error) => (
  (error && error.response && error.response.data && error.response.data.message)
  || 'Não foi possível concluir. Tente de novo.'
);

// Cópia "antiga" (execCommand): funciona onde a API de clipboard é negada.
// O textarea vai dentro do diálogo para não perder o foco preso pelo MUI.
const copiarComTextarea = (texto, container) => {
  const area = document.createElement('textarea');
  area.value = texto;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  const pai = container || document.body;
  pai.appendChild(area);
  area.select();
  const ok = document.execCommand('copy');
  pai.removeChild(area);
  return ok ? Promise.resolve() : Promise.reject(new Error('copy'));
};

const copiar = (texto, container) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(texto).catch(() => copiarComTextarea(texto, container));
  }
  return copiarComTextarea(texto, container);
};

function SendToCustomerDialog({ open, onClose, scope, notify }) {
  const history = useHistory();
  const [link, setLink] = useState('');
  const [email, setEmail] = useState('');
  const [sentAt, setSentAt] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !scope) return;
    setEmail((scope.customer && scope.customer.email) || scope.prospect_email || '');
    setSentAt(scope.customer_data_requested_at || null);
    setError('');
    setLoading(true);
    apiCreate(`salesscope/${scope.id}/send-customer-link`, { send_email: false })
      .then((res) => setLink(res.link))
      .catch((err) => setError(mensagemDoErro(err)))
      .finally(() => setLoading(false));
  }, [open, scope]);

  const enviar = () => {
    setLoading(true);
    setError('');
    apiCreate(`salesscope/${scope.id}/send-customer-link`, { email: email.trim() })
      .then((res) => {
        setLink(res.link);
        setSentAt(res.customer_data_requested_at);
        notify(NOTIFICATION_TYPE_SUCCESS, res.message || 'Link enviado');
      })
      .catch((err) => {
        setError(mensagemDoErro(err));
        notify(NOTIFICATION_TYPE_ERROR, mensagemDoErro(err));
      })
      .finally(() => setLoading(false));
  };

  const copiarLink = (e) => {
    const container = e && e.currentTarget ? e.currentTarget.closest('[role="dialog"]') : null;
    copiar(link, container)
      .then(() => notify(NOTIFICATION_TYPE_SUCCESS, 'Link copiado. Cole no WhatsApp do cliente.'))
      .catch(() => notify(NOTIFICATION_TYPE_ERROR, 'Não consegui copiar. Selecione o link e copie.'));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Enviar para o cliente</DialogTitle>
      <DialogContent>
        <DialogContentText>
          O cliente abre o link, preenche os dados de cadastro e cai direto no contrato para assinar.
          Ele também recebe por e-mail o contrato e o acesso à Central do Cliente.
        </DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Link da venda"
              value={link}
              InputProps={{ readOnly: true }}
              onFocus={(e) => e.target.select()}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField
              fullWidth
              variant="outlined"
              label="E-mail do cliente"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              style={{ height: 56 }}
              onClick={enviar}
              disabled={loading || !email}
            >
              Enviar por e-mail
            </Button>
          </Grid>
          {sentAt && (
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                {`Último envio por e-mail: ${moment(sentAt).format('DD/MM/YYYY [às] HH:mm')}`}
              </Typography>
            </Grid>
          )}
          {loading && (
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <CircularProgress size={24} />
            </Grid>
          )}
          {error && (
            <Grid item xs={12}>
              <Typography color="error">{error}</Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={copiarLink} disabled={!link}>Copiar link</Button>
        <Button onClick={() => history.push('/venda')}>Voltar para as vendas</Button>
        <Button onClick={onClose} color="primary">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default connect(null, { notify: showNotification })(SendToCustomerDialog);
